import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { AzureBlobCopySource } from 'app/model/pipeline/copysource/azure-blob.copysource';
import { BlobSink } from 'app/model/pipeline/copysink/blob.copysink';
import { AzureTableSink } from 'app/model/pipeline/copysink/azure-table.copysink';
import { AzureTableCopySource } from 'app/model/pipeline/copysource/azure-table.copysource';
import { sasUriSetting } from 'app/registries/linked-service/azure-storage-shared-fields';
import { accountKeyConnectionStringSetting } from '../consts/metadata-consts-with-ec-deps';
import { azureStorageAuthTypes } from 'shell-models-lib';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const azureStorageMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.azureStorage.linkedServiceType,
    displayName: stringResources.AzureStorage_DisplayText,
    icon: {
        className: 'svg-i-100x100-AzureBlob'
    },
    queryAlias: 'azureTableSourceQuery',
    isFirstClass: true,
    supportIncrementalBinaryCopy: true,
    notShowInTypeSelection: true,
    supportGetMetadataActivity: true,
    copySinkTypes: [Metamodel.modelFor(BlobSink).name, Metamodel.modelFor(AzureTableSink).name],
    copySourceTypes: [Metamodel.modelFor(AzureBlobCopySource).name, Metamodel.modelFor(AzureTableCopySource).name],
    category: ['Azure'],
    onetimeQueryTemplate: '',
    // eslint-disable-next-line max-len
    timedQueryTemplate: '<<columnName>> gt datetime\'@{formatDateTime(pipeline().parameters.windowStart, \'yyyy-MM-ddTHH:mmZ\' )}\' \nand <<columnName>> le datetime\'@{formatDateTime(pipeline().parameters.windowEnd, \'yyyy-MM-ddTHH:mmZ\' )}\'',
    controls: [
        {
            type: 'select-switch',
            bind: 'authenticationMethod',
            label: stringResources.Authentication_Method_Label,
            options: [
                {
                    label: stringResources.AuthenticationType_AccountKey,
                    value: azureStorageAuthTypes.AccountKeyAuthentication
                },
                {
                    label: stringResources.SasUri,
                    value: azureStorageAuthTypes.SasUriAuthentication
                }
            ],
            isLabelVertical: true,
            defaultValue: 'AccountKeyAuthentication',
            cases: [
                {
                    caseValue: azureStorageAuthTypes.AccountKeyAuthentication,
                    children: [
                        accountKeyConnectionStringSetting()
                    ]
                },
                {
                    caseValue: azureStorageAuthTypes.SasUriAuthentication,
                    children: [
                        sasUriSetting(false)
                    ]
                }
            ]
        }
    ]
};
